import { Header } from "../../components/Header";
import ArrowDoubleSide from "../../components/icons/ArrowDoubleSide";
import "./index.scss";
const AboutUs = () => {
    return(
        <div className="page splash aboutUsPage">
            <div className="background" />
            <Header />
            <div className="green-text">
                Agilysys offers the broadest integrated hospitality
                software portfolio with the deepest functionality in the
                market, empowering the friendly and generous reception
                of guests and members by providing accommodation,
                food, drink, entertainment or other services to deliver a
                truly exceptional experience across their entire journey.
            </div>
            <div className="text-wrapper">
                <div className="head">
                    Agilysys Hospitality Experience Cloud
                </div>
                <div className="body">
                    The comprehensive <strong>High Return Hospitality</strong> solution{'\n'}
                    <span>where personal meets profitable</span>
                </div>
                <div className="footer">
                    Higher Guest Returns
                    <ArrowDoubleSide />
                    Higher Economic Returns
                </div>
            </div>
        </div>
    )
}
export default AboutUs;